var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCategoryPalette(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33301 19.9999C3.33301 29.2047 10.7949 36.6666 19.9997 36.6666C22.7611 36.6666 24.9997 34.428 24.9997 31.6666V30.8333C24.9997 30.0592 24.9997 29.6722 25.0425 29.3473C25.3378 27.1036 27.1034 25.3381 29.347 25.0427C29.672 24.9999 30.059 24.9999 30.833 24.9999H31.6663C34.4278 24.9999 36.6663 22.7613 36.6663 19.9999C36.6663 10.7952 29.2044 3.33325 19.9997 3.33325C10.7949 3.33325 3.33301 10.7952 3.33301 19.9999Z",
    stroke: "#6374A6",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6663 21.6666C12.5868 21.6666 13.333 20.9204 13.333 19.9999C13.333 19.0794 12.5868 18.3333 11.6663 18.3333C10.7459 18.3333 9.99967 19.0794 9.99967 19.9999C9.99967 20.9204 10.7459 21.6666 11.6663 21.6666Z",
    stroke: "#6374A6",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6663 14.9999C27.5868 14.9999 28.333 14.2537 28.333 13.3333C28.333 12.4128 27.5868 11.6666 26.6663 11.6666C25.7459 11.6666 24.9997 12.4128 24.9997 13.3333C24.9997 14.2537 25.7459 14.9999 26.6663 14.9999Z",
    stroke: "#6374A6",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6663 13.3333C17.5868 13.3333 18.333 12.5871 18.333 11.6666C18.333 10.7461 17.5868 9.99992 16.6663 9.99992C15.7459 9.99992 14.9997 10.7461 14.9997 11.6666C14.9997 12.5871 15.7459 13.3333 16.6663 13.3333Z",
    stroke: "#6374A6",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoryPalette);
export default __webpack_public_path__ + "react/media/category-palette.27f3edbad921ec3849ab3ae0e1438981.svg";
export { ForwardRef as ReactComponent };